import { render, staticRenderFns } from "./CatalogItemTable.vue?vue&type=template&id=844f3dc6&"
import script from "./CatalogItemTable.vue?vue&type=script&lang=js&"
export * from "./CatalogItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports